import { useContext } from 'react';
import { ProductOptionEditorContext, ProductOptionEditorContextProps } from '../context/ProductOptionEditorContext';

export const useProductOptionEditor = (): ProductOptionEditorContextProps => {
  const context = useContext(ProductOptionEditorContext);
  if (!context) {
    throw new Error('useProductOptionEditor must be used within a ProductOptionEditorProvider');
  }
  return context;
};
